__turbopack_context__.v({
  "season_navigator": "aSGO1G_season_navigator",
  "season_navigator__episodes": "aSGO1G_season_navigator__episodes",
  "season_navigator__loading": "aSGO1G_season_navigator__loading",
  "season_navigator_select": "aSGO1G_season_navigator_select",
});
